import moment from 'moment-timezone';
import { formatAddress } from './formatAddress';
import { authHash, userId } from '../../config';

const submitForm = async (getState, occupationId, address, techId, reCaptchaToken) => {
  const date = getState('date', moment());
  const time = getState('time');

  const formattedAddress = formatAddress(address);
  const isAsap = getState('isASAP');
  const startTime = isAsap ? moment() : moment(date).set('hour', time.get('hour')).set('minute', time.get('minute'));
  const tz = address.timeZone;

  const schedule = {
    schedule_type: isAsap ? 'ASAP' : 'DATE_TIME',
    start_time: startTime.unix() * 1000,
    timezone: tz || 'America/Los_Angeles',
  };

  const services = getState('service');

  const body = {
    client_name: getState('clientName'),
    client_phonenumber: getState('clientPhone'),
    occupation_id: occupationId,
    sched_info: schedule,
    description: getState('notes', ''),
    job_sub_category_id: getState('subCategoryId'),
    address: formattedAddress,
    created_id: userId,
  };

  if (services) {
    body.services = services;
  }

  const init = {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      Timestamp: Date.now(),
      AuthKey: authHash,
      techId,
      reCAPTCHA: reCaptchaToken,
    }
  };

  const response = await fetch('/api/mysite/createJob', init);

  if (response.status === 201) {
    return { success: true };
  }

  const { message } = await response.json().catch(() => ({}));

  return { success: false, message };
};

export default submitForm;
